// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"435":"d3e34492","453":"fbaf8072","934":"583152ef"}[chunkId] + ".chunk.js";
};